module.exports = __webpack_public_path__ + "static/media/mobileMovement.0faa9772.svg";